import z from "zod";
import { cbHttp } from "./http.service"
import { DocumentationSchema } from "@/schemas/documentation.schema";
import { DocumentationCreationResultSchema } from "@/schemas/documentation-form.schema";

export const getDocumentationIndex = (index: string): Promise<z.infer<typeof DocumentationSchema>> => {
    return cbHttp.get("/api/documentation/".concat(index));
}

export const getDocumentationStructuresPreBuild = (): Promise<string> => {
    return cbHttp.get("/api/documentation/documentationsidebarstructureprebuild");
}

export const postCreateDocumentation = (data: FormData): Promise<z.infer<typeof DocumentationCreationResultSchema>> => {
    return cbHttp.post("/api/documentation/createdocumentation", data);
}

export const postUpdateDocumentation = (data: FormData): Promise<string> => {
    return cbHttp.post("/api/documentation/updatedocumentation", data);
}